'use strict';
/* ===================================================================================== @preserve =
 ___  _   _    _
/   || | | |  | |
\__  | | | |  | |  __
/    |/  |/_) |/  /  \_/\/
\___/|__/| \_/|__/\__/  /\_/
              |\
              |/
Ajaxinate
version v2.0.4
https://github.com/Elkfox/Ajaxinate
Copyright (c) 2017 Elkfox Co Pty Ltd
https://elkfox.com
MIT License
================================================================================================= */

var Ajaxinate = function ajaxinateConstructor(config) {
  var settings = config || {};
  /*
    pagination: Selector of pagination container
    container: Selector of repeating content
    offset: 0, offset the number of pixels before the bottom to start loading more on scroll
    loadingText: 'Loading', The text changed during loading
    callback: null, function to callback after a new page is loaded
  */

  var defaultSettings = {
    method: 'scroll',
    container: '#AjaxinateContainer',
    pagination: '#AjaxinatePagination',
    offset: 0,
    loadingText: 'Loading',
    callback: null
  }; // Merge configs

  this.settings = Object.assign(defaultSettings, settings);
  this.addScrollListeners = this.addScrollListeners.bind(this);
  this.addClickListener = this.addClickListener.bind(this);
  this.checkIfPaginationInView = this.checkIfPaginationInView.bind(this);
  this.stopMultipleClicks = this.stopMultipleClicks.bind(this);
  this.removeClickListener = this.removeClickListener.bind(this);
  this.removeScrollListener = this.removeScrollListener.bind(this);
  this.destroy = this.destroy.bind(this);
  this.containerElement = document.querySelector(this.settings.container);
  this.paginationElement = document.querySelector(this.settings.pagination);
  this.initialize();
};

Ajaxinate.prototype.initialize = function initializeTheCorrectFunctionsBasedOnTheMethod() {
  if (this.containerElement) {
    var initializers = {
      click: this.addClickListener,
      scroll: this.addScrollListeners
    };
    initializers[this.settings.method]();
  }
};

Ajaxinate.prototype.addScrollListeners = function addEventListenersForScrolling() {
  if (this.paginationElement) {
    document.addEventListener('scroll', this.checkIfPaginationInView);
    window.addEventListener('resize', this.checkIfPaginationInView);
    window.addEventListener('orientationchange', this.checkIfPaginationInView);
   
  }
};

Ajaxinate.prototype.addClickListener = function addEventListenerForClicking() {
  if (this.paginationElement) {
    this.nextPageLinkElement = this.paginationElement.querySelector('a');
    this.clickActive = true;

    if (typeof this.nextPageLinkElement !== 'undefined' && this.nextPageLinkElement !== null) {
      this.nextPageLinkElement.addEventListener('click', this.stopMultipleClicks);
    }
  }
};

Ajaxinate.prototype.stopMultipleClicks = function handleClickEvent(event) {
  event.preventDefault();

  if (this.clickActive) {
    
    this.nextPageLinkElement.innerHTML = this.settings.loadingText;
    this.nextPageUrl = this.nextPageLinkElement.href;
    this.clickActive = false;

    //console.log("stopMultipleClicks")
    //console.log(this.nextPageUrl)

    const load_type = this.nextPageLinkElement.getAttribute("load-type");

    if(load_type == 'load-on-click'){
      //console.log("load on click");
      this.loadPrevious();
    }else {
      this.loadMore();
    }

    
  }
};

Ajaxinate.prototype.checkIfPaginationInView = function handleScrollEvent() {
  var top = this.paginationElement.getBoundingClientRect().top - this.settings.offset;
  var bottom = this.paginationElement.getBoundingClientRect().bottom + this.settings.offset;

  if (top <= window.innerHeight && bottom >= 0) {
    this.nextPageLinkElement = this.paginationElement.querySelector('a');
    this.removeScrollListener();

    if (this.nextPageLinkElement) {

      if(document.querySelector("#AjaxinatePagination a") != null) {

        const product_grid = document.querySelector("#product-grid");
        const listHeight = product_grid.querySelector(".card__inner").clientHeight;

        const template = `<li class="grid__item grid-placeholder" style="height:${listHeight}px;"></li>
        <li class="grid__item grid-placeholder" style="height:${listHeight}px;"></li>
        <li class="grid__item grid-placeholder" style="height:${listHeight}px;"></li>
        <li class="grid__item grid-placeholder" style="height:${listHeight}px;"></li>
        <li class="grid__item grid-placeholder" style="height:${listHeight}px;"></li>
        <li class="grid__item grid-placeholder" style="height:${listHeight}px;"></li>
        <li class="grid__item grid-placeholder" style="height:${listHeight}px;"></li>
        <li class="grid__item grid-placeholder" style="height:${listHeight}px;"></li>
        <li class="grid__item grid-placeholder" style="height:${listHeight}px;"></li>
        <li class="grid__item grid-placeholder" style="height:${listHeight}px;"></li>
        <li class="grid__item grid-placeholder" style="height:${listHeight}px;"></li>
        <li class="grid__item grid-placeholder" style="height:${listHeight}px;"></li>`;
        product_grid.insertAdjacentHTML("beforeend", template);
      }

      this.nextPageLinkElement.innerHTML = this.settings.loadingText;
      this.nextPageUrl = this.nextPageLinkElement.href;
      this.loadMore();

    }
  }
};

Ajaxinate.prototype.loadMore = function getTheHtmlOfTheNextPageWithAnAjaxRequest() {
  this.request = new XMLHttpRequest();

  this.request.onreadystatechange = function success() {
    if (this.request.readyState === 4 && this.request.status === 200) {
      var newContainer = this.request.responseXML.querySelectorAll(this.settings.container)[0];
      var newPagination = this.request.responseXML.querySelectorAll(this.settings.pagination)[0];
      this.containerElement.insertAdjacentHTML('beforeend', newContainer.innerHTML);
      this.paginationElement.innerHTML = newPagination.innerHTML;

      if (this.settings.callback && typeof this.settings.callback === 'function') {
        this.settings.callback(this.request.responseXML);
      }

      this.initialize();
    }

    const load_type_method = document.querySelector("#AjaxinatePagination").getAttribute("load-type");
    if(load_type_method == 'load-on-click'){
      window.history.pushState("", "", this.nextPageUrl);
    }
    
  }.bind(this);

  this.request.open('GET', this.nextPageUrl);
  this.request.responseType = 'document';
  this.request.send();

  const product_grid = document.querySelector("#product-grid");
  const listHeight = product_grid.querySelector(".card__inner").clientHeight;

  const template = `<li class="grid__item grid-placeholder" style="height:${listHeight}px;"></li>
  <li class="grid__item grid-placeholder" style="height:${listHeight}px;"></li>
  <li class="grid__item grid-placeholder" style="height:${listHeight}px;"></li>
  <li class="grid__item grid-placeholder" style="height:${listHeight}px;"></li>
  <li class="grid__item grid-placeholder" style="height:${listHeight}px;"></li>
  <li class="grid__item grid-placeholder" style="height:${listHeight}px;"></li>
  <li class="grid__item grid-placeholder" style="height:${listHeight}px;"></li>
  <li class="grid__item grid-placeholder" style="height:${listHeight}px;"></li>
  <li class="grid__item grid-placeholder" style="height:${listHeight}px;"></li>
  <li class="grid__item grid-placeholder" style="height:${listHeight}px;"></li>
  <li class="grid__item grid-placeholder" style="height:${listHeight}px;"></li>
  <li class="grid__item grid-placeholder" style="height:${listHeight}px;"></li>`;
  product_grid.insertAdjacentHTML("beforeend", template);
};

Ajaxinate.prototype.loadPrevious = function getTheHtmlOfTheNextPageWithAnAjaxRequest() {
  this.request = new XMLHttpRequest();

  this.request.onreadystatechange = function success() {
    if (this.request.readyState === 4 && this.request.status === 200) {
      var newContainer = this.request.responseXML.querySelectorAll(this.settings.container)[0];
      var newPagination = this.request.responseXML.querySelectorAll(this.settings.pagination)[0];
      //console.log(this.containerElement);
      //console.log(newContainer.innerHTML);
      this.containerElement.innerHTML = newContainer.innerHTML;
      this.paginationElement.innerHTML = newPagination.innerHTML;

      if (this.settings.callback && typeof this.settings.callback === 'function') {
        this.settings.callback(this.request.responseXML);
      }

      this.initialize();
    }
    //console.log("previous page url");
    //console.log(this.nextPageUrl)
    window.history.pushState("", "", this.nextPageUrl);
    
    
  }.bind(this);

  this.request.open('GET', this.nextPageUrl);
  this.request.responseType = 'document';
  this.request.send();
 
};


Ajaxinate.prototype.removeClickListener = function removeClickEventListener() {
  this.nextPageLinkElement.removeEventListener('click', this.stopMultipleClicks);
};

Ajaxinate.prototype.removeScrollListener = function removeScrollEventListener() {
  document.removeEventListener('scroll', this.checkIfPaginationInView);
  window.removeEventListener('resize', this.checkIfPaginationInView);
  window.removeEventListener('orientationchange', this.checkIfPaginationInView);
};

Ajaxinate.prototype.destroy = function removeEventListenersAndRemoveThis() {
  var destroyers = {
    click: this.removeClickListener,
    scroll: this.removeScrollListener
  };
  destroyers[this.settings.method]();
  return this;
};